import {DateTime} from "luxon";
import {ProblemTicketInterface} from "@api/models/interfaces/tickets/ProblemTicketInterface";
import {Ticket} from "./Ticket";

export class Problem extends Ticket implements ProblemTicketInterface {
    isAnonymous: boolean | null;
    riskLocation: string | null;
    riskLevel: string | null;
    implementationDate: string | DateTime | null;
}
